exports.inject = function(module) {
  module.factory('AuthInterceptor', ['$window', '$q', '$location', 'GUEST_ALLOW', 'IMPERSONATION', exports.factory]);
};

exports.factory = function($window, $q, $location, GUEST_ALLOW, IMPERSONATION) {
  function isGuestPage(path) {
    var result = false;
    angular.forEach(GUEST_ALLOW, function(str) {
      if(path.indexOf(str) !== -1) {
        result = true;
      }
    });
    return result;
  }
  function isTryingImpersonation(path) {
    return path.indexOf(IMPERSONATION) > -1;
  }
  
  function responseError(response) {
    if(response.status == 401 && !isGuestPage($location.path()) && !isTryingImpersonation($location.path())) {
      // Unauthorized (not authenticated)
      $window.localStorage.userInfo = null;
      $location.path("login");
    }
    return $q.reject(response);
  }

  return {
    responseError: responseError
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/auth-interceptor.js
 ** module id = 232
 ** module chunks = 0
 **/